module.exports = __webpack_public_path__ + "img/fillllll.1421ed35.svg";